export default __webpack_public_path__ + "static/strawberry-pointing-up-e16a5bbbcf5ababcb4ae01edad36dcec.svg";